import { createAxiosClient } from "@ntg/component-library/utilities";
import { useMutation } from "@tanstack/react-query";

const apiClient = createAxiosClient("D365FO");

interface IRollbackManufacturingSalesOrderLinesPayload {
    includeD365Cleanup: boolean;
    mItemID: number;
}

async function rollbackManufacturingSalesOrderLines(
    payload: IRollbackManufacturingSalesOrderLinesPayload,
): Promise<string> {
    const response = await apiClient.post<string>(
        "/FunctionAppsStarter/RollbackManufacturingSalesOrderLines",
        payload,
    );
    return response.data;
}

export function useRollbackManufacturingSalesOrderLines() {
    return useMutation({
        mutationFn: rollbackManufacturingSalesOrderLines,
    });
}
